export default "__VITE_ASSET__BHoC$9AC__"